// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  assignmentId: __t.u64().name("assignment_id"),
  attemptNumber: __t.u32().name("attempt_number"),
  checkId: __t.string().name("check_id"),
  stepId: __t.string().name("step_id"),
  tryNumber: __t.u32().name("try_number"),
  selectedOptionIds: __t.array(__t.string()).name("selected_option_ids"),
  correct: __t.bool(),
  expired: __t.bool(),
  sessionId: __t.u64().name("session_id"),
  identity: __t.identity(),
  answeredAt: __t.timestamp().name("answered_at"),
});
